import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1006">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1007">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1008">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1009">
          {isOpen ? <XIcon size={24} data-id="element-1010" /> : <PlusIcon size={24} data-id="element-1011" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1012">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1013">
          {answer}
        </p>
      </div>
    </div>;
}
export function DVFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Is diVa Vaginal Laser Treatment?',
    answer: 'diVa Vaginal Laser Treatment is a non-invasive procedure that uses advanced laser technology to resurface the vaginal wall, replacing damaged tissue with new, healthy tissue. It addresses various concerns like lack of lubrication, urinary incontinence, painful intercourse and vaginal irritation.'
  }, {
    question: 'How Does It Work?',
    answer: "The procedure utilizes hybrid fractional laser technology to create controlled micro-injuries in the vaginal tissue, stimulating the body's natural healing response. This process promotes collagen and elastin production, leading to tissue regeneration and improved vaginal health."
  }, {
    question: 'Is Vaginal Rejuvenation Painful?',
    answer: 'Most patients report no discomfort during a diVa laser procedure, which typically lasts about 15-30 minutes.'
  }, {
    question: 'How Many Treatments Are Needed?',
    answer: 'The number of treatments required may vary depending on individual needs, but a series of 3-4 treatments spaced 2-4 weeks apart is often recommended for optimal results. While some improvement may be noticed shortly after treatment, full results are usually observed gradually over several weeks to months as collagen remodeling occurs.'
  }, {
    question: 'Are There Any Side Effects Or Downtime?',
    answer: 'Side effects are rare and minimal, with most patients experiencing only minor redness and swelling following the procedure. Patients can typically resume their daily activities immediately after treatment, as there is no downtime associated with diVa Vaginal Laser Treatment.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1014">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1015">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1016">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1017">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1018"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1019">
          <div className="space-y-2" data-id="element-1020">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1021" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}